import {
  IconBorderAll,
  IconCircles,
  IconCreditCard,
  IconFileDescription,
  IconFolder,
  IconGift,
  IconKey,
  IconLink,
  IconMail,
  IconRotateRectangle,
  IconShieldHalfFilled,
  IconUser,
  IconUsers,
} from '@tabler/icons';
import { FC, useContext } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import NavigationLink from '../../Atoms/Navigation/NavigationLink';
import { useNavigationItem } from '../../Organismns/Navigation/NavigationItemHook';
import { WindowContext } from '../../Service/Context/WindowContext';
import { TestS } from '../../TestS';
import { ConstantS } from '../../Service/ConstantS';
import { MixpanelS } from '../../Service/MixpanelS';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import { LicenceS } from '../../Service/LicenceS';
import { ThemeTitle } from '../../Atoms/ThemeText';

const SettingsNavbar: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const { sm } = useContext(WindowContext);
  const navigate: NavigateFunction = useNavigate();
  const { profile } = useContext<any>(ProfileContext);
  const resourceItemActive = useNavigationItem('/settings/resources');

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = (path: string, section: string) => {
    navigate(path);
    closeNavBar();
    MixpanelS.track(ConstantS.TrackingEvents.ViewContent, { page: 'Settings', section });
  };

  return (
    <>
      {!sm && (
        <ThemeTitle p="md" order={3} mb={5}>
          Einstellungen
        </ThemeTitle>
      )}
      <NavigationLink
        variant="filled"
        label="Profil"
        onClick={() => _onClick('/settings/userdata', 'Profile')}
        active={useNavigationItem('/settings/userdata')}
        icon={sm && sm && <IconUser size={16} />}
        testId={TestS.Navigate.SETTINGS_TO_USER_DATA}
      />
      <NavigationLink
        variant="filled"
        label="Freunde werben"
        onClick={() => _onClick('/settings/recruitment', 'Recruitment')}
        active={useNavigationItem('/settings/recruitment')}
        icon={sm && <IconGift size={16} />}
      />
      <NavigationLink label="Paket &amp; Abrechnung" icon={sm && <IconCreditCard size={16} />} childrenOffset={28}>
        <NavigationLink
          label="Paket"
          active={useNavigationItem('/settings/plans')}
          onClick={() => _onClick('/settings/plans', 'Billing plans')}
          variant="filled"
        />
      </NavigationLink>

      <NavigationLink
        label="Eigene Felder, Status & Art"
        icon={sm && <IconBorderAll size={16} />}
        childrenOffset={28}
        variant="filled"
      >
        <NavigationLink
          label="Eigene Felder"
          active={useNavigationItem('/settings/customfields')}
          onClick={() => _onClick('/settings/customfields', 'Custom fields')}
          variant="filled"
        />
        <NavigationLink
          label="Eigene Status"
          active={useNavigationItem('/settings/eventstates')}
          onClick={() => _onClick('/settings/eventstates', 'Event states')}
          variant="filled"
        />
        <NavigationLink
          label="Eigene Auftragsarten"
          active={useNavigationItem('/settings/eventkinds')}
          onClick={() => _onClick('/settings/eventkinds', 'Event kinds')}
          variant="filled"
        />
      </NavigationLink>

      <NavigationLink label="Integrationen" icon={sm && <IconLink size={16} />} childrenOffset={28} variant="filled">
        <NavigationLink
          label="Google-Sync"
          active={useNavigationItem('/settings/google')}
          onClick={() => _onClick('/settings/google', 'Google panel')}
          variant="filled"
        />
        <NavigationLink
          label="Kalender-Sync"
          active={useNavigationItem('/settings/calendar')}
          onClick={() => _onClick('/settings/calendar', 'External calendar')}
          variant="filled"
        />
        {profile && profile.kindOfWebsite && (
          <NavigationLink
            label="Webseite verbinden"
            active={location.pathname.includes('connectwebsite')}
            onClick={() => _onClick('/settings/connectwebsite', 'Connect website')}
            variant="filled"
          />
        )}
        <NavigationLink
          label="Kontaktformulare"
          active={useNavigationItem('/settings/contact-form')}
          onClick={() => _onClick('/settings/contact-form', 'Contact form')}
          variant="filled"
        />
        <NavigationLink
          label="Buchhaltung"
          active={useNavigationItem('/settings/bookkeeping')}
          onClick={() => _onClick('/settings/bookkeeping', 'Bookkeeping')}
          variant="filled"
        />
      </NavigationLink>

      <NavigationLink
        label="Dienstleister-Netzwerk"
        icon={sm && <IconUsers size={16} />}
        active={useNavigationItem('/settings/team')}
        onClick={() => _onClick('/settings/team', 'Team')}
        variant="filled"
      />
      {profile && LicenceS.hasAccessToResourceModule(profile.id) && (
        <NavigationLink
          label="Ressourcen"
          icon={sm && <IconCircles size={16} />}
          active={resourceItemActive}
          onClick={() => _onClick('/settings/resources', 'Resources')}
          variant="filled"
        />
      )}
      <NavigationLink
        label="Workflow"
        icon={sm && <IconRotateRectangle size={16} />}
        active={useNavigationItem('/settings/workflow')}
        onClick={() => _onClick('/settings/workflow', 'Workflow')}
        variant="filled"
      />

      <NavigationLink label="E-Mail" icon={sm && <IconMail size={16} />} childrenOffset={28} variant="filled">
        <NavigationLink
          label="Vorlagen"
          active={useNavigationItem('/settings/messages')}
          onClick={() => _onClick('/settings/messages', 'Messages')}
          variant="filled"
        />

        <NavigationLink
          label="Agenturvorlagen"
          active={useNavigationItem('/settings/agency/messages')}
          onClick={() => _onClick('/settings/agency/messages', 'Agency-Messages')}
          variant="filled"
        />

        <NavigationLink
          label="Ausgangsserver"
          active={useNavigationItem('/settings/mail-account')}
          onClick={() => _onClick('/settings/mail-account', 'Mail-account')}
          variant="filled"
        />
        <NavigationLink
          label="Signatur"
          active={useNavigationItem('/settings/signature')}
          onClick={() => _onClick('/settings/signature', 'Signature')}
          variant="filled"
        />
      </NavigationLink>

      <NavigationLink
        label="Dokumente"
        icon={sm && <IconFileDescription size={16} />}
        childrenOffset={28}
        variant="filled"
        testId={TestS.Navigate.SETTINGS_TO_DOCUMENTS}
      >
        <NavigationLink
          label="Dokument-Vorlagen"
          active={useNavigationItem('/settings/templates')}
          onClick={() => _onClick('/settings/templates', 'Document templates')}
          variant="filled"
        />
        <NavigationLink
          label="Produkte"
          active={useNavigationItem('/settings/positions')}
          onClick={() => _onClick('/settings/positions', 'Products')}
          variant="filled"
        />
        <NavigationLink
          label="Fragebogen-Vorlagen"
          active={useNavigationItem('/settings/questionnaires')}
          onClick={() => _onClick('/settings/questionnaires', 'Questionnaires templates')}
          variant="filled"
        />
        <NavigationLink
          label="Vertrags-Vorlagen"
          active={useNavigationItem('/settings/contracts')}
          onClick={() => _onClick('/settings/contracts', 'Contracts templates')}
          variant="filled"
        />
        <NavigationLink
          label="Dokument-Layout"
          active={useNavigationItem('/settings/documents')}
          onClick={() => _onClick('/settings/documents', 'Dokument Layout')}
          variant="filled"
          testId={TestS.Navigate.SETTINGS_TO_DOCUMENT_LAYOUT}
        />
        <NavigationLink
          label="Mehrwertsteuer"
          active={useNavigationItem('/settings/taxes')}
          onClick={() => _onClick('/settings/taxes', 'Taxes')}
          variant="filled"
          testId={TestS.Navigate.SETTINGS_TO_TAXES}
        />
        <NavigationLink
          label="Nummernkreise"
          active={useNavigationItem('/settings/sequentialnumbers')}
          onClick={() => _onClick('/settings/sequentialnumbers', 'Sequential numbers')}
          variant="filled"
        />
      </NavigationLink>

      <NavigationLink
        label="Dateien"
        icon={sm && <IconFolder size={16} />}
        active={useNavigationItem('/settings/files')}
        onClick={() => _onClick('/settings/files', 'Files')}
        variant="filled"
      />
      <NavigationLink
        label="Datenschutz"
        icon={sm && <IconShieldHalfFilled size={16} />}
        active={useNavigationItem('/settings/gdpr')}
        onClick={() => _onClick('/settings/gdpr', 'GDPR')}
        variant="filled"
      />
      <NavigationLink
        label="Passwort &amp; Account"
        icon={sm && <IconKey size={16} />}
        active={useNavigationItem('/settings/account')}
        onClick={() => _onClick('/settings/account', 'Account details')}
        variant="filled"
      />
    </>
  );
};

export default SettingsNavbar;
